import { gql } from "@apollo/client";

// Fragments
export const USER_NOTIFICATION_FRAGMENT = gql`
  fragment UserNotificationFragment on UserNotification {
    id
    salonId
    userId
    title
    message
    actionText
    actionUrl
    schemaKey
    priority
    category
    referenceId
    referenceType
    isRead
    readAt
    createdAt
    updatedAt
    deliveryEvents {
      id
      channel
      status
      sentAt
      metadata
    }
  }
`;

// Legacy alias for backward compatibility during transition
export const NOTIFICATION_FRAGMENT = USER_NOTIFICATION_FRAGMENT;

export const NOTIFICATION_STATS_FRAGMENT = gql`
  fragment NotificationStatsFragment on NotificationStats {
    total
    unread
    urgent
    todayCount
    weekCount
  }
`;

// Legacy alias for backward compatibility during transition
export const USER_NOTIFICATION_STATS_FRAGMENT = NOTIFICATION_STATS_FRAGMENT;

// Queries
export const GET_NOTIFICATIONS = gql`
  ${USER_NOTIFICATION_FRAGMENT}
  query GetNotifications(
    $salonId: ID!
    $first: Float
    $after: String
  ) {
    getNotifications(
      salonId: $salonId
      first: $first
      after: $after
    ) {
      edges {
        node {
          ...UserNotificationFragment
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

// Legacy alias for backward compatibility during transition
export const GET_USER_NOTIFICATIONS = GET_NOTIFICATIONS;

export const GET_UNREAD_NOTIFICATIONS = gql`
  ${USER_NOTIFICATION_FRAGMENT}
  query GetUnreadNotifications(
    $salonId: ID!
    $first: Float = 10
  ) {
    getNotifications(
      salonId: $salonId
      first: $first
    ) {
      edges {
        node {
          ...UserNotificationFragment
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

// Legacy alias for backward compatibility during transition
export const GET_UNREAD_USER_NOTIFICATIONS = GET_UNREAD_NOTIFICATIONS;

export const GET_NOTIFICATION_STATS = gql`
  ${NOTIFICATION_STATS_FRAGMENT}
  query GetNotificationStats(
    $salonId: ID!
  ) {
    getNotificationStats(
      salonId: $salonId
    ) {
      ...NotificationStatsFragment
    }
  }
`;

// Legacy alias for backward compatibility during transition
export const GET_USER_NOTIFICATION_STATS = GET_NOTIFICATION_STATS;

// Mutations
export const MARK_NOTIFICATIONS_AS_READ = gql`
  mutation MarkNotificationsAsRead($input: MarkNotificationsReadInput!) {
    markNotificationsAsRead(input: $input)
  }
`;

// Legacy alias for backward compatibility during transition
export const MARK_USER_NOTIFICATIONS_AS_READ = MARK_NOTIFICATIONS_AS_READ;

// Device Token Management Mutations
export const REGISTER_DEVICE_TOKEN = gql`
  mutation RegisterDeviceToken($token: String!, $platform: String!, $deviceId: String) {
    registerDeviceToken(token: $token, platform: $platform, deviceId: $deviceId)
  }
`;

export const UNREGISTER_DEVICE_TOKEN = gql`
  mutation UnregisterDeviceToken($token: String!) {
    unregisterDeviceToken(token: $token)
  }
`;

export const GET_USER_DEVICE_TOKENS = gql`
  query GetUserDeviceTokens {
    getUserDeviceTokens
  }
`;

// Subscriptions (temporarily disabled - requires WebSocket setup)
// export const NOTIFICATION_RECEIVED = gql`
//   ${USER_NOTIFICATION_FRAGMENT}
//   subscription NotificationReceived(
//     $salonId: ID!
//   ) {
//     notificationReceived(
//       salonId: $salonId
//     ) {
//       ...UserNotificationFragment
//     }
//   }
// `;

// // Legacy alias for backward compatibility during transition
// export const USER_NOTIFICATION_RECEIVED = NOTIFICATION_RECEIVED;

// export const NOTIFICATION_STATS_UPDATED = gql`
//   ${NOTIFICATION_STATS_FRAGMENT}
//   subscription NotificationStatsUpdated(
//     $salonId: ID!
//   ) {
//     notificationStatsUpdated(
//       salonId: $salonId
//     ) {
//       ...NotificationStatsFragment
//     }
//   }
// `;

// // Legacy alias for backward compatibility during transition
// export const USER_NOTIFICATION_STATS_UPDATED = NOTIFICATION_STATS_UPDATED;
